import { useTranslation } from "react-i18next";
import { PaymentType } from "../../api/types";
import {
  Box,
  Button,
  Dialog,
  Flex,
  Heading,
  IconButton,
  Text,
} from "@radix-ui/themes";
import { Cross1Icon } from "@radix-ui/react-icons";
import { useAppDispatch } from "../../store";
import {
  hidePaymentModal,
  setPaymentArgs,
} from "../../store/slices/modalsSlice";

interface PaymentFailedProps {
  statusCode?: string;
  onRetry: () => void;
  paymentType: PaymentType;
  onTryAnother: (newType: PaymentType) => void;
}

export function PaymentFailed({ statusCode, onRetry }: PaymentFailedProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <Box className="w-full p-8">
      <Dialog.Close className="!absolute !top-5 !right-5">
        <IconButton
          variant="ghost"
          color="gray"
          highContrast
          size="3"
          onClick={() => {
            dispatch(hidePaymentModal());
            setTimeout(() => {
              dispatch(setPaymentArgs(null));
            }, 0);
          }}
        >
          <Cross1Icon width={18} height={18} />
        </IconButton>
      </Dialog.Close>
      <Flex
        justify="between"
        align="center"
        direction="column"
        className="w-full h-full"
      >
        <figure className="flex justify-center">
          <img src="/error.png" className="w-[100px] h-[100px]" />
        </figure>
        <Heading size="6" mb="2" weight="bold" color="gray" highContrast>
          {t("paymentFailed")}
        </Heading>
        <Flex direction="column" gap="3" mb="6">
          <Text as="p" size="3" align="center" color="gray">
            {t("paymentFailedDescription")}
          </Text>
          {statusCode && (
            <Text size="1" align="center" color="red">
              {t("statusCode")}: {statusCode}
            </Text>
          )}
        </Flex>
        <Button
          size="4"
          className="w-[100%!important]"
          variant="solid"
          onClick={onRetry}
        >
          {t("tryAgain")}
        </Button>
        {/* <Separator
          size="4"
          className="my-2 mb-6 relative after:content-['or'] after:absolute after:left-1/2 after:bg-white after:text-gray-600 after:px-4 after:-translate-x-2/4 after:top-[-13px]"
        ></Separator>
        <Button
          size="4"
          className="w-[100%!important]"
          variant="outline"
          onClick={() => {
            if (paymentType === PaymentType.Terminal) {
              onTryAnother(PaymentType.App);
            } else {
              onTryAnother(PaymentType.Terminal);
            }
          }}
        >
          {paymentType === PaymentType.Terminal
            ? t("payWithCard")
            : t("payWithApp")}
        </Button> */}
      </Flex>
    </Box>
  );
}
